export class KDSTopLevelPermission
{
    showUsers : boolean;
    showGroups : boolean;
}